const Builder = require('../BuilderBase');

module.exports = class MultiPickerShortText extends Builder {
    constructor(title, properties) {
        super('formElement_MultiPickerShortText', title, properties);
    }
};
